<template>
  <beta-banner />
  <page-loader v-if="showLoader" :label="loaderLabel" />
  <RouterView v-if="ready" />
</template>

<script>
import PageLoader from '@components/page-loader.vue';
import useGlobalStore from '@stores/global';
import BetaBanner from '@components/layout/beta-banner.vue';

const SIGN_IN_LINK_ERRORS = {
  invalid: 'This sign-in link is invalid or has expired',
  failed: 'Something went wrong signing you in, please refresh the page',
};

export default {
  name: 'App',
  components: {
    PageLoader,
    BetaBanner,
  },
  data() {
    return {
      ready: false,
      store: useGlobalStore(),
    };
  },
  computed: {
    showLoader() {
      return !this.ready || this.store.isLoggingOut;
    },
    loaderLabel() {
      return this.store.isLoggingOut ? 'Logging out' : 'Loading';
    },
    routeApplicationId() {
      const { applicationId } = this.$route.params;
      return applicationId ? Number(applicationId) : null;
    },
  },
  watch: {
    // A Retry can load the list after the route.
    routeApplicationId: 'rememberRouteApplication',
    'store.applicationIds': 'rememberRouteApplication',
  },
  created() {
    this.$router.beforeResolve((to, from) => this.routerBeforeResolve(to, from));
  },
  beforeMount() {
    // The first navigation waits for the session, so the page can be shown once it has finished.
    this.$router.isReady().then(() => {
      this.ready = true;
      // Shown with the page rather than from the session guard, so it isn't hidden by the loader.
      this.showSignInLinkError();
    });
  },
  methods: {
    showSignInLinkError() {
      const message = SIGN_IN_LINK_ERRORS[this.store.signInLinkError];
      if (message) {
        this.$ktoast.error(message);
        this.store.signInLinkError = null;
      }
    },
    routerBeforeResolve(to, from) {
      this.$logger.resetRouteId();
      this.$logger.info(
        `Moving to page ${to.name}`,
        {
          from: from.fullPath,
          to: to.fullPath,
        },
        true,
      );
      if (from.path !== to.path) {
        this.$httpCancel();
      }
    },
    rememberRouteApplication() {
      if (this.routeApplicationId !== null) {
        this.store.rememberApplication(this.routeApplicationId);
      }
    },
  },
};
</script>
